export const general: GeneralSetup = {
    documentDescription:
        'Master decision-making in uncertainty with Startup Poker. Learn to make critical go/no-go decisions, assess the value of information, know when to end innovation projects, and understand how competition shapes success.',
    documentTitle: 'Startup Poker - Kromatic',
    favicon: '/favicon.png',
    portionMarking: null,
    siteName: 'Kromatic',
    socialDescription:
        'Practice go / no-go decisions, value-of-information tradeoffs, and competition strategy with Kromatic’s Startup Poker simulation.',
    socialImage: '/assets/landing/illustration.png',
    socialImageAlt: 'Startup Poker simulation preview illustration from Kromatic',
    socialTitle: 'Startup Poker | Kromatic',
};
